import { store } from '../../app/store'
import { hepApiSlice } from '../hep/hepApiSlice'
import { usersApiSlice } from '../users/usersApiSlice';
import { exercisesApiSlice } from '../exercises/exercisesApiSlice';
import { hepexercisesApiSlice } from '../hep/hepexercisesApiSlice';
import { bodypartsApiSlice } from '../exercises/bodypartsApiSlice';
import { exercisetypesApiSlice } from '../exercises/exercisetypesApiSlice';
import { todoApiSlice } from '../todo/todoApiSlice';

import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

const Prefetch = () => {

    useEffect(() => {
        store.dispatch(hepApiSlice.util.prefetch('getHep', 'hepList', { force: true }))
        store.dispatch(usersApiSlice.util.prefetch('getUsers', 'usersList', { force: true }))
        store.dispatch(exercisesApiSlice.util.prefetch('getExercises', 'exercisesList', { force: true }))
        store.dispatch(hepexercisesApiSlice.util.prefetch('getHepExercises', 'hepexercisesList', { force: true }))
        store.dispatch(bodypartsApiSlice.util.prefetch('getBodyparts', 'bodypartsList', { force: true }))
        store.dispatch(exercisetypesApiSlice.util.prefetch('getExercisetypes', 'exercisetypesList', { force: true }))
        store.dispatch(todoApiSlice.util.prefetch('getTodos', 'todoList', { force: true }))
    }, [])

    return <Outlet />
}
export default Prefetch
